import { render, staticRenderFns } from "./proposedProject.vue?vue&type=template&id=19b63591&scoped=true&"
import script from "./proposedProject.vue?vue&type=script&lang=js&"
export * from "./proposedProject.vue?vue&type=script&lang=js&"
import style0 from "./proposedProject.vue?vue&type=style&index=0&id=19b63591&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b63591",
  null
  
)

export default component.exports